export const MixpanelProperty = {
    Action: "Action",
    AppVersion: "AppVersion",
    BulkOperationId: "Bulk Operation Id",
    Category: "Category",
    CloseAction: "CloseAction",
    Column: "Column",
    ColumnsExported: "Columns Exported",
    ConsentOrigin: "Consent Origin",
    DaysAsDraft: "Days As Draft",
    Direction: "Direction",
    DistinctId: "distinct_id",
    Entity: "Entity",
    EntityCount: "Entity Count",
    Event: "Event",
    ExpiryLength: "Expiry Length",
    ExportDurationMs: "Export Duration Ms",
    ExportedEntity: "Exported Entity",
    Field: "Field",
    FileSizeBytes: "File Size Bytes",
    FilteredFields: "Filtered Fields",
    FlowName: "FlowName",
    HasCustomMessage: "Has Custom Message",
    HasSearch: "Has Search",
    InitiatorSource: "Initiator Source",
    Insight: "Insight",
    IsAutomationInitiated: "Is Automation Initiated",
    IsChecked: "IsChecked",
    IsSuggested: "Is Suggested",
    LinkType: "LinkType",
    Location: "Location",
    Modal: "Modal",
    Name: "Name",
    NeedsAttention: "Needs attention",
    NumberOfFailedOperations: "Number Of Failed Operations",
    NumberOfRunningOperations: "Number Of Running Operations",
    NumberOfScanningTenants: "Number Of Scanning Tenants",
    NumberOfWorkspaces: "Number Of Workspaces",
    Operation: "Operation",
    Page: "Page",
    PreviousUrl: "Previous URL",
    Region: "Region",
    ReportKind: "Report Kind",
    ReportName: "Report Name",
    ReportSource: "Report Source",
    ReviewId: "Review Id",
    ReviewTypes: "Review Types",
    SGAccountId: "SGAccountId",
    SelectionMode: "Selection Mode",
    ShareCount: "Share Count",
    ShareId: "Share Id",
    Source: "Source",
    Status: "Status",
    Sublocation: "Sublocation",
    Tab: "Tab",
    TenantId: "Tenant Id",
    Template: "Template",
    Text: "Text",
    TotalAffectedItems: "Total Affected Items",
    TotalItems: "Total Items",
    TotalItemsExported: "Total Items Exported",
    TotalSkippedItems: "Total Skipped Items",
    TotalTargetedItems: "Total Targeted Items",
    Trigger: "Trigger",
    Type: "Type",
    Url: "Url",
    UtmCampaign: "utm_campaign",
    UtmContent: "utm_content",
    UtmMedium: "utm_medium",
    UtmSource: "utm_source",
    UtmTerm: "utm_term",
    Values: "Values",
    WorkspaceId: "WorkspaceId"
} as const;

export type MixpanelProperty = (typeof MixpanelProperty)[keyof typeof MixpanelProperty];
